import React, { useState, useEffect } from 'react';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { Container, Row, Col, Card, Button, Form, Table, InputGroup, Modal } from 'react-bootstrap';
import { FaSearch, FaPlus, FaEdit, FaTrash, FaFilter, FaSave, FaTimes, FaMapMarkerAlt } from 'react-icons/fa';
import { auth } from '../../services/firebaseConnection';
import { db } from '../../services/firebaseConnection';
import { doc, setDoc, getDoc, updateDoc, getDocs, collection, deleteDoc } from 'firebase/firestore';
import UserRegister from './Register';

// Componente de formulário para adicionar/editar cliente
function UserForm({ cliente, onSave, onCancel }) {
  
  const [formData, setFormData] = useState({
    documentId: cliente?.documentId || null,
    name: cliente?.name || '',
    cnpj: cliente?.cnpj || '',
    email: cliente?.email || '',
    phone: cliente?.phone || '',
    permission: cliente?.permission || 'Ativo',
    // Campos de endereço
    rua: cliente?.rua || '',
    numero: cliente?.numero || '',
    complemento: cliente?.complemento || '',
    bairro: cliente?.bairro || '',
    cep: cliente?.cep || '',
    cidade: cliente?.cidade || '',
    estado: cliente?.estado || '',
  });
}

export default function CreateUsers() {

  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [currentCliente, setCurrentCliente] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState('');
  const [allUsers, setAllUsers] = useState([]);

  // useEffect para filtrar usuários baseado no termo de busca
  useEffect(() => {
    const filteredUsers = allUsers.filter(user => {
      const searchTermLower = searchTerm.toLowerCase();
      return (
        (user.name && user.name.toLowerCase().includes(searchTermLower)) ||
        (user.email && user.email.toLowerCase().includes(searchTermLower)) ||
        (user.permission && user.permission.toLowerCase().includes(searchTermLower)) ||
        (user.phone && user.phone.toLowerCase().includes(searchTermLower)) ||
        (user.cidade && user.cidade.toLowerCase().includes(searchTermLower)) ||
        (user.estado && user.estado.toLowerCase().includes(searchTermLower))
      );
    });
    setUsers(filteredUsers);
  }, [searchTerm, allUsers]);

  // useEffect para buscar usuários na montagem do componente
  useEffect(() => {
    fetchUsers();
  }, []);

  // Função para fechar modal
  const closeModal = () => {
    setShowModal(false);
    setCurrentCliente(null);
  };

  // Função para deletar usuário
  const handleDeleteUser = async (documentId) => {
    if (window.confirm("Tem certeza que deseja excluir este usuário?")) {
      try {
        await deleteDoc(doc(db, "users", documentId));
        setUsers(users.filter(user => user.documentId !== documentId));
        setAllUsers(allUsers.filter(user => user.documentId !== documentId));
        alert("Usuário excluído com sucesso!");
      } catch (error) {
        console.error("Erro ao excluir usuário: ", error);
        alert("Erro ao excluir usuário. Tente novamente.");
      }
    }
  };

  // Função para salvar cliente
  const handleSaveCliente = async (cliente) => {
    const cnpjClean = cliente.cnpj ? cliente.cnpj.replace(/[^\d]+/g, '') : '';

    if (!cnpjClean) {
      alert('CNPJ é obrigatório.');
      return;
    }

    try {
      // Verificar se é edição baseado no documentId (que vem do Firebase)
      if (cliente.documentId) {
        // É uma edição - atualizar documento existente
        console.log('Editando cliente com documentId:', cliente.documentId);
        
        const userRef = doc(db, 'users', cliente.documentId);
        await updateDoc(userRef, {
          name: cliente.name,
          email: cliente.email,
          phone: cliente.phone,
          permission: cliente.permission,
          rua: cliente.rua,
          numero: cliente.numero,
          complemento: cliente.complemento,
          bairro: cliente.bairro,
          cep: cliente.cep,
          cidade: cliente.cidade,
          estado: cliente.estado
        });
        
        // Atualizar estado local
        setUsers(users.map(u => 
          u.documentId === cliente.documentId 
            ? { ...cliente, documentId: cliente.documentId }
            : u
        ));
        setAllUsers(allUsers.map(u => 
          u.documentId === cliente.documentId 
            ? { ...cliente, documentId: cliente.documentId }
            : u
        ));
        
      } else {
        // É um novo cliente - verificar duplicidade
        console.log('Criando novo cliente');
        
        const userRef = doc(db, 'users', cnpjClean);
        const existingDoc = await getDoc(userRef);

        if (existingDoc.exists()) {
          alert('Já existe um cliente cadastrado com este CNPJ.');
          return;
        }

        // Criar novo cliente
        const novoUsuario = {
          name: cliente.name,
          cnpj: cliente.cnpj,
          email: cliente.email,
          phone: cliente.phone,
          permission: cliente.permission,
          rua: cliente.rua,
          numero: cliente.numero,
          complemento: cliente.complemento,
          bairro: cliente.bairro,
          cep: cliente.cep,
          cidade: cliente.cidade,
          estado: cliente.estado
        };

        await setDoc(userRef, novoUsuario);
        setUsers([...users, { ...novoUsuario, documentId: cnpjClean }]);
        setAllUsers([...allUsers, { ...novoUsuario, documentId: cnpjClean }]);
      }

      setShowForm(false);
      setCurrentCliente(null);
      
    } catch (error) {
      console.error('Erro ao salvar cliente:', error);
      alert('Erro ao salvar cliente. Tente novamente.');
    }
  };

  // Função para buscar usuários do Firebase
  const fetchUsers = async () => {
    try {
      console.log("=== FETCHANDO Usuarios ===");
      const usersSnapshot = await getDocs(collection(db, 'users'));
      
      const usersList = usersSnapshot.docs.map(doc => {
        const data = doc.data();
        return { documentId: doc.id, ...data };
      });
      
      setUsers(usersList);
      setAllUsers(usersList);
    } catch (error) {
      console.error("Erro ao buscar usuários:", error);
      setError("Erro ao carregar usuários: " + error.message);
    }
  };

  return(
    <Container fluid className="p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Gerenciamento de Usuários</h1>
        <Button 
          variant="primary" 
          onClick={() => { setCurrentCliente(null); setShowModal(true); }}
        >
          <FaPlus className="me-2" /> Novo Usuário
        </Button>
      </div>

      {/* Barra de pesquisa com filtro */}
      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <Row>
            <Col>
              <InputGroup>
                <InputGroup.Text>
                  <FaSearch />
                </InputGroup.Text>
                <Form.Control
                  placeholder="Buscar por nome, email, phone, cidade, estado ou permission..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                {searchTerm && (
                  <Button 
                    variant="outline-secondary" 
                    onClick={() => setSearchTerm('')}
                  >
                    <FaTimes />
                  </Button>
                )}
              </InputGroup>
              {searchTerm && (
                <small className="text-muted mt-2 d-block">
                  Mostrando {users.length} de {allUsers.length} usuários
                </small>
              )}
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Formulário de cliente (condicional) */}
      {showForm && (
        <UserForm 
          cliente={currentCliente} 
          onSave={handleSaveCliente} 
          onCancel={() => { setShowForm(false); setCurrentCliente(null); }} 
        />
      )}

      {/* Tabela de usuários */}
      <Card className="shadow-sm">
        <Card.Body>
          <div className="table-responsive">
            <Table hover>
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Email</th>
                  <th>Telefone</th>
                  <th>Cidade/Estado</th>
                  <th>Permissão</th>
                  <th className="text-end">Ações</th>
                </tr>
              </thead>
              <tbody>
                {users.length > 0 ? (
                  users.map((user) => (
                    <tr key={user.documentId}>
                      <td>{user.name || '-'}</td>
                      <td>{user.email || '-'}</td>
                      <td>{user.phone || '-'}</td>
                      <td>{user.cidade && user.estado ? `${user.cidade}/${user.estado}` : '-'}</td>
                      <td>
                        <span className={` 
                        ${user.permission === 'administrador' ? 
                          'bg-success p-2 text-white rounded' : 
                          'bg-secondary  p-2 text-white rounded'
                        }`}>
                          {user.permission || 'Indefinido'}
                        </span>
                      </td>
                      <td className="text-end">
                        <Button
                          variant="outline-primary"
                          size="sm"
                          className="me-2"
                          onClick={() => {
                            setCurrentCliente(user);
                            setShowModal(true);
                          }}
                        >
                          <FaEdit />
                        </Button>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => handleDeleteUser(user.documentId)}
                        >
                          <FaTrash />
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center text-muted py-4">
                      {searchTerm ? 'Nenhum usuário encontrado com os critérios de busca.' : 'Nenhum usuário cadastrado.'}
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>

      {/* Modal para registro de usuário */}
      <Modal show={showModal} onHide={closeModal} size="xl">
        <Modal.Body>
          <UserRegister onCancel={closeModal} />
        </Modal.Body>
      </Modal>

    </Container>
  );
}

